var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "ca-form" },
      [
        _c(
          "el-form",
          {
            ref: "fixRequestForm",
            staticClass: "form-container",
            attrs: {
              model: _vm.fixRequestForm,
              rules: _vm.rules,
              autocomplete: "on",
              "label-position": "left",
              size: "mini",
            },
          },
          [
            _c(
              "el-row",
              [
                _c(
                  "div",
                  {
                    staticStyle: {
                      "font-size": "larger",
                      "font-weight": "bold",
                    },
                  },
                  [_vm._v("Open Editor in new Tab")]
                ),
                _c(
                  "center",
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.editFloorplan },
                      },
                      [_vm._v("Edit Floorplan")]
                    ),
                    _c("br"),
                    _c("span", { staticStyle: { "font-size": "x-small" } }, [
                      _vm._v("Model Id: " + _vm._s(_vm.fixRequestForm.modelId)),
                    ]),
                  ],
                  1
                ),
                _c("hr"),
              ],
              1
            ),
            _c(
              "el-row",
              [
                _c("br"),
                _c(
                  "div",
                  {
                    staticStyle: {
                      "font-size": "larger",
                      "font-weight": "bold",
                    },
                  },
                  [_vm._v("Submit a Fix Request Form")]
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "Instructions for Cubicasa." } },
                  [
                    _c("el-input", {
                      attrs: {
                        maxlength: "1000",
                        placeholder: "Tell Cubicasa what to change...",
                        type: "textarea",
                        rows: 3,
                      },
                      model: {
                        value: _vm.fixRequestForm.instructions,
                        callback: function ($$v) {
                          _vm.$set(_vm.fixRequestForm, "instructions", $$v)
                        },
                        expression: "fixRequestForm.instructions",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "el-row",
              [
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label:
                        "Optional mockup Image to illustrate the fix request.",
                    },
                  },
                  [
                    _c("br"),
                    _c("FixRequestUploader", {
                      on: { input: _vm.getAttachment },
                      model: {
                        value: _vm.imageUrl,
                        callback: function ($$v) {
                          _vm.imageUrl = $$v
                        },
                        expression: "imageUrl",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
    _c(
      "div",
      {
        staticClass: "dialog-footer",
        staticStyle: { "text-align": "center", "margin-top": "10px" },
        attrs: { slot: "footer" },
        slot: "footer",
      },
      [
        _c("el-button", { on: { click: _vm.handleClose } }, [_vm._v("Cancel")]),
        _c(
          "el-button",
          { attrs: { type: "primary" }, on: { click: _vm.submitForm } },
          [_vm._v("Submit Fix Request")]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }